import { useState } from "react";
import { HashRouter, Routes, Route, useParams } from "react-router-dom";
import { Context } from "./common/js/context";
import { Lang, getDefaultLang } from "./common/js/i18n";
import Dashboard from "./pages/Dashboard";
import Welcome from "./pages/Welcome";
import Detail from "./pages/share/Detail";

function SharedDetail() {
    let params = useParams();
    let schemeId = params.schemeId;
    if (schemeId) {
        return (
            <Detail schemeId={schemeId} />
        );
    } else {
        return (
            <p>Invalid parameter!</p>
        );
    }
}

function getCookie(key: string) {
    var arr1 = document.cookie.split("; ");//由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
    for (var i = 0; i < arr1.length; i++) {
        var arr2 = arr1[i].split("=");//通过=截断，把name=Jack截断成[name,Jack]数组；
        if (arr2[0] === key) {
            return decodeURI(arr2[1]);
        }
    }
}

function setCookie(name: string, value: string, expires?: number) {
    const expiresTime = new Date(new Date().getTime() + (expires || 7 * 24 * 3600 * 1000));
    document.cookie = `${name}=${escape(value)};Expires=${expiresTime.toUTCString()}; Path=/`;
}

function App() {
    let [lang, setLang] = useState((getCookie("lang") || getDefaultLang() || Lang.En) as Lang);
    return (
        <Context.Provider value={{
            lang, setLang: (lang) => {
                setCookie("lang", lang);
                setLang(lang);
            }
        }}>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Welcome />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/open/:schemeId" element={<SharedDetail />} />
                </Routes>
            </HashRouter>
        </Context.Provider>
    );
}

export default App;
